// /**
//  * Order detail -CSV
//  */

// React
import React from 'react';
import { CSVLink } from 'react-csv';
import { Order } from '../orders/interfaces';
import { mdiArrowCollapseDown, mdiArrowDownBoldOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { Button } from '@material-ui/core';

type Props = {
  data: Order[];
  loading: boolean;
};

function CSV(props: Props) {
  const flattData = (data: any) => {
    return data.map((item: any) => {
      return {
        orderItemId: item.id,
        productName: item.productName,
        productCode: item.productCode,
        variantCode: item.variantCode,
        variantId: item.variantId,
        amount: item.amount,
      };
    });
  };

  return (
    <CSVLink
      data={flattData(props.data)}
      filename="Orders.csv"
      style={{
        textDecoration: 'none',
      }}
    >
      <Button
        style={{ marginLeft: '8px' }}
        variant="outlined"
        color="primary"
        size="medium"
        startIcon={<Icon path={mdiArrowDownBoldOutline} size={'16px'} />}
      >
        Excel
      </Button>
    </CSVLink>
  );
}

export default CSV;
